const repRankingsConfig = {
  context: 'rep',
  key: 'rep_stack_metrics',
  defaultMetrics: [ 'revenuePerBillableHour', 'revenuePerCall', 'salesPerBillableHour', 'salesPerMachineHour' ],
}

export { repRankingsConfig }
